import React from "react";

// mititicidco — Marathwada Private ITI, CIDCO N-4, Ch. Sambhajinagar
// Content translated from the Marathi brochure.

export const TRADES = [
  {
    key: "electrician",
    nameMr: "विजतंत्री",
    nameEn: "Electrician",
    qualification: "SSC Pass",
    duration: "2 Years",
    units: 2,
    intake: 20,
    accent: "#B45309",
    highlights: [
      "In-depth knowledge of the electrical sector — theory + practicals per NCVT syllabus",
      "Maintenance & repair of every kind of electric motor — 3-phase, single-phase, AC and all DC motors",
      "Repair, maintenance, connection and diagnostics of all AC & DC starters",
      "Domestic and industrial wiring — installation, maintenance and repair",
      "Panel wiring, motor rewinding and other factory-level electrical work",
      "Repair, installation and maintenance of generators, alternators and transformers",
      "Foundation-level electronics as part of the integrated curriculum",
    ],
    prospects: [
      "Operator posts at MSEB / state electricity boards",
      "Electrician Assistant / Supervisor roles in factories",
      "Start your own electrical business (self-employment)",
      "Recruitment openings with ST Corporation, Indian Railways, NTPC, etc.",
      "Craft Instructor positions in Government & Private ITIs",
    ],
  },
  {
    key: "diesel",
    nameMr: "यांत्रिकी डिझेल",
    nameEn: "Mechanic Diesel",
    qualification: "SSC Pass",
    duration: "1 Year",
    units: 2,
    intake: 48,
    accent: "#0F766E",
    highlights: [
      "Detailed exposure to every automotive tool and instrument used in the trade",
      "Petrol and Diesel engines including MPFI and CRDI — parts, working, service",
      "Complete engine repair, maintenance, testing and start-up procedures",
      "Auto-electric vehicle systems and diagnostics",
      "Ancillary auto components — battery, alternator, starter and more",
      "Wheel alignment, steering, transmission and braking systems",
      "Practical driving training included in the programme",
    ],
    prospects: [
      "Start your own automobile garage",
      "Open a 2-wheeler & 4-wheeler service centre",
      "Establish a fuel-injection pump repair and calibration centre",
      "Craft Instructor role in Government & Private ITIs",
      "Placements at OEMs — Mahindra, Tata, Eicher, Hyundai and more",
      "Mechanic-grade recruitment at Railways, ST Corporation and PSU depots",
    ],
  },
];

export const UPCOMING_COURSES = [
  { title: "Solar Technician", icon: "sun" },
  { title: "Computer Operator and Programming Assistant (COPA)", icon: "monitor" },
  { title: "Technician Power Electronics System", icon: "cpu" },
  { title: "Refrigeration and Air-Conditioner Technician", icon: "snowflake" },
];

export const OBJECTIVES = [
  "Supply skilled manpower required by industry across varied job roles",
  "Empower youth with training that makes them employment-ready in factories",
  "Enable skill-based self-employment in manufacturing and services",
  "Support industry in improving quality, standards and productivity",
];

export const FEATURES = [
  "All trade units affiliated with the Central Government (NCVT, New Delhi)",
  "Modern purpose-built building with well-equipped workshops",
  "Experienced and specialist instructors across every trade",
  "Spacious computer laboratory",
  "Well-equipped library",
  "On-campus Employment & Self-Employment Guidance Cell",
  "Curriculum, examinations and certification identical to Government ITIs",
];

export const FACILITIES = [
  { title: "Modern Purpose-built Campus", desc: "Located inside the MIT Campus at CIDCO N-4, Chhatrapati Sambhajinagar — spacious classrooms, workshops and administrative wings." },
  { title: "Trade Workshops", desc: "Well-equipped Electrician and Mechanic-Diesel workshops with modern tools, machines and safety infrastructure." },
  { title: "Spacious Computer Laboratory", desc: "Fully-networked lab with workstations, projector and syllabus-mapped digital learning material." },
  { title: "Well-equipped Library", desc: "Technical references, syllabus manuals, competitive-exam books and periodicals for trainees." },
  { title: "Conference Hall", desc: "Dedicated hall for expert lectures, faculty meetings, industry interactions and student inductions." },
  { title: "Employment & Self-Employment Cell", desc: "Placement guidance, mock interviews and self-employment mentoring for outgoing trainees." },
];

export const ACTIVITIES = [
  { title: "Shivrajyabhishek Day", mr: "शिवराज्याभिषेक दिवस", desc: "Cultural celebration commemorating the coronation of Chhatrapati Shivaji Maharaj." },
  { title: "Convocation / Dikshant Ceremony", mr: "दीक्षांत (पदवीदान) समारंभ", desc: "Certificates distributed to trainees who successfully complete their programme." },
  { title: "Expert Guidance Lectures", mr: "तज्ञाचे मार्गदर्शन", desc: "Sessions by industry professionals covering current industrial practices and career pathways." },
  { title: "Institute Foundation Day", mr: "संस्था स्थापना दिन", desc: "Annual celebration of the institute&apos;s founding in 2017 with cultural programmes and awards." },
  { title: "Constitution Day", mr: "संविधान दिन", desc: "Reading of the Preamble and reflections on constitutional values on 26 November." },
  { title: "Health & Safety Workshops", mr: "आरोग्य व सुरक्षा कार्यशाळा", desc: "Regular workshops on workshop safety, PPE and first-response for industrial injuries." },
];

// Staff / instructor listing (from the source document).
export const STAFF = [
  {
    name: "Prof. M. A. Patil",
    designation: "Principal",
    qualification: "S.S.C., D.M.E., D.E.E., Post Diploma in Auto Engg., Radio Servicing, A.M.I.E. (Mechanical Engg.), B.A., M.A. (Economics), L.L.B., Diploma in IT, Advanced Diploma in IT",
    dob: "05 December 1943",
    phone: "9325213062 / 8830686560",
    email: "mapatil2004@gmail.com",
  },
  {
    name: "Shri M. B. Randive",
    designation: "Instructor · Electrician Trade",
    qualification: "I.T.I. (Electrician) + C.T.I.",
    dob: "04 February 1956",
    phone: "9423028503",
    email: "mahavirrandive2120@gmail.com",
  },
  {
    name: "Shri S. G. Kannurkar",
    designation: "Instructor · Mechanic Diesel Trade",
    qualification: "Diploma in Mechanical Engineering",
    dob: "04 October 1954",
    phone: "9579737503",
    email: "kannurkarstcwa@gmail.com",
  },
  {
    name: "Junior Instructor",
    designation: "Instructor · Electrician Trade",
    qualification: "Diploma in Electronics & Telecommunication, B.E. (Electrical, Electronics & Power)",
    dob: "30 July 1997",
    phone: "7798604036",
    email: "",
  },
  {
    name: "Shri S. D. Raut",
    designation: "Clerk",
    qualification: "B.A. (Economics) and M.B.A. (H.R.)",
    dob: "08 October 1992",
    phone: "9970530334",
    email: "sunil.raut@mit.asia",
  },
  {
    name: "Shri S. J. Rathod",
    designation: "Peon (100395)",
    qualification: "S.S.C.",
    dob: "05 June 1971",
    phone: "9623165036",
    email: "saidas.rathod@mit.asia",
  },
];

export function PageHero({ eyebrow, title, sub }) {
  return (
    <div className="relative overflow-hidden bg-gradient-to-r from-[#7C2D12] via-[#9A3412] to-[#7C2D12] text-white">
      <div className="absolute inset-0 opacity-10" style={{ backgroundImage: "radial-gradient(circle at 90% 20%, #D4A017 0, transparent 45%), radial-gradient(circle at 10% 80%, #FDF6E3 0, transparent 40%)" }} />
      <div className="relative max-w-6xl mx-auto px-5 py-14">
        {eyebrow && <div className="text-[10px] uppercase tracking-[0.35em] font-bold text-[#D4A017]">{eyebrow}</div>}
        <h1 className="font-serif text-3xl sm:text-4xl mt-2 leading-tight">{title}</h1>
        {sub && <p className="mt-3 text-white/85 text-sm max-w-3xl">{sub}</p>}
      </div>
    </div>
  );
}

export function Section({ children, className = "" }) {
  return <section className={`max-w-6xl mx-auto px-5 py-14 ${className}`}>{children}</section>;
}
